// **********************************************************
// Dealer Map
// **********************************************************

/* global google, windowWidth, breakpointMd */

const dealerMapElements = document.querySelectorAll('.dealer-map__init');

if (dealerMapElements.length > 0) {
  const dealerMapPinsEle = document.querySelectorAll('[data-marker]');
  const markers = [];
  const extraSpace = document.querySelector('.dealer-map__extra-space');
  const defaultZoom = parseFloat(document.querySelector('.dealer-map__init').getAttribute('data-zoom'));

  let activeMarker = null;

  // Zoom back out and re-center
  const mapZoomAndPan = (map) => {
    if (windowWidth() >= breakpointMd) {
      map.setZoom(defaultZoom);
    }
  };

  const setCenterMap = (lat, lng, map) => {
    map.setCenter(new google.maps.LatLng(lat, lng));
  };

  const detailScrollIntoView = (card) => {
    const parentDropdown = card.closest('.location-popup__dropdown');
    const scrollableContainer = parentDropdown.querySelector('.location-popup__dropdown-inner');
    if (!scrollableContainer) return;
    const dropdownHeader = parentDropdown.querySelector('.location-popup__dropdown-header')?.clientHeight;

    const cardOffsetTop = card.offsetTop;
    const containerScrollTop = scrollableContainer.scrollTop;
    const containerHeight = scrollableContainer.clientHeight;
    const cardHeight = card.offsetHeight;

    const isAbove = cardOffsetTop < containerScrollTop + dropdownHeader + 12;
    const isBelow = cardOffsetTop + cardHeight > containerScrollTop + containerHeight;

    if (isAbove || isBelow) {
      scrollableContainer.scrollTo({
        top: Math.max(0, cardOffsetTop - dropdownHeader - 12),
        behavior: 'smooth',
      });
    }
  };

  const openPopup = (card) => {
    if (!card) return;

    const popupEle = card.closest('.location-popup');
    const isOpen = popupEle.classList.contains('.is-items-open');
    const isMobileOpen = popupEle.classList.contains('.is-open');
    popupEle.classList.toggle('is-items-open', !isOpen);

    popupEle.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));

    const navItem = card.closest('.location-popup__nav-item.has-dropdown');
    navItem?.classList.add('is-active');

    const details = card.closest('.location-details');
    details?.classList.add('is-active');

    setTimeout(() => {
      detailScrollIntoView(details);
    }, 600);

    if (windowWidth() <= breakpointMd) {
      popupEle.classList.toggle('is-open', !isMobileOpen);
    }

    const cardDataSlugElem = card.querySelector('[data-slug]');
    if (cardDataSlugElem) {
      const cardDataSlugValue = cardDataSlugElem.getAttribute('data-slug');
      if (cardDataSlugValue) {
        window.history.pushState({}, '', `#${cardDataSlugValue}`);
      }
    }
  };

  // Custom Map Marker
  class AnimatedMarker extends google.maps.OverlayView {
    constructor(position, map, options = {}) {
      super();
      this.position = position;
      this.map = map;
      this.options = options;
      this.div = null;
      this.active = false;

      this.setMap(map);
    }

    onAdd() {
      const div = document.createElement('div');
      div.className = this.options.defaultClass || 'custom-marker';
      div.style.position = 'absolute';
      div.style.cursor = 'pointer';

      if (this.options.icon) {
        const img = document.createElement('img');
        img.src = this.options.icon;
        img.alt = 'HQ Marker';
        img.width = 100;
        img.height = 100;
        div.appendChild(img);
      }

      div.addEventListener('click', () => {
        if (typeof this.options.onClick === 'function') {
          this.options.onClick(this);
        }
      });

      this.div = div;

      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(div);
    }

    draw() {
      if (!this.div) return;

      const projection = this.getProjection();
      const point = projection.fromLatLngToDivPixel(this.position);

      if (point) {
        this.div.style.left = `${point.x}px`;
        this.div.style.top = `${point.y}px`;
      }
    }

    onRemove() {
      if (this.div && this.div.parentNode) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    }

    setActive(active) {
      this.active = active;
      if (!this.div) return;

      const { activeClass = 'is-active', defaultClass = '' } = this.options;

      // check BEFORE resetting
      const isHovered = this.div.classList.contains('is-hovered');

      this.div.className = defaultClass;

      if (isHovered) {
        this.div.classList.add('is-hovered');
      }

      if (active) {
        this.div.classList.add(activeClass);
      }
    }

    getPosition() {
      return this.position;
    }

    setVisible(visible) {
      if (this.div) {
        this.div.style.display = visible ? 'block' : 'none';
      }
    }
  }

  const initMarkers = (pins, map) => {
    Array.prototype.forEach.call(pins, (elm) => {
      const pinLat = elm.getAttribute('data-marker-lat');
      const pinLng = elm.getAttribute('data-marker-lng');
      const markerSlug = elm.getAttribute('data-slug');
      const markerName = elm.getAttribute('data-tag');
      // const mapPinIcon = elm.getAttribute('data-marker');
      const tooltipContent = elm.getAttribute('data-tooltip');
      const infoCard = document.querySelector(`[data-popup="${markerName}"]`);
      const isCountryMarker = elm.classList.contains('location-popup__link');

      const isHQMarker = elm.classList.contains('dealer-map__hq');
      const iconUrl = isHQMarker ? elm.getAttribute('data-marker') : null;

      // eslint-disable-next-line no-unused-vars
      const marker = new AnimatedMarker(new google.maps.LatLng(pinLat, pinLng), map, {
        defaultClass:
          !isCountryMarker &&
          (isHQMarker ? 'location-marker location-marker--hq' : 'location-marker location-marker--default'),
        activeClass: !isCountryMarker && (isHQMarker ? 'location-marker--hq-active' : 'location-marker--active'),
        tooltip: tooltipContent || '',
        visible: !isCountryMarker,
        icon: iconUrl,
        onClick: (m) => {
          if (activeMarker) activeMarker.setActive(false);
          activeMarker = m;
          m.setActive(true);
          map.panTo(m.getPosition());
          centerTheMap();
          setTimeout(() => openPopup(infoCard), 200);

          if (isHQMarker) {
            const popupEle = document.querySelector('.location-popup');
            if (popupEle.classList.contains('is-items-open') || popupEle.classList.contains('is-open')) {
              popupEle.classList.remove('is-open');
              const backButton = popupEle.querySelector(
                '.location-popup__nav-item.is-active .location-popup__back-button',
              );
              backButton?.click();
            }
          }
        },
      });
      marker.slug = markerSlug;

      const centerTheMap = () => {
        if (map.getZoom() <= defaultZoom) {
          map.setZoom(defaultZoom + 1);
        }

        if (windowWidth() >= breakpointMd) {
          const extraSpaceWidth = extraSpace.offsetWidth / 3;

          map.panBy(-extraSpaceWidth, 0);
        }
      };

      marker.addListener('click', () => {
        activeMarker?.setActive(false);
        activeMarker = marker;
        marker.setActive(true);

        openPopup(infoCard);

        // Center active marker
        map.panTo(marker.getPosition());

        // Pan map so it's centered at the right place relative to the popups
        centerTheMap();
      });

      elm.addEventListener('click', () => {
        activeMarker?.setActive(false);
        activeMarker = marker;
        marker.setActive(true);

        openPopup(infoCard);
        // Center map
        setCenterMap(pinLat, pinLng, map);

        // Pan map so it's centered at the right place relative to the popups
        centerTheMap();
      });

      // Push the marker to the 'markers' array
      markers.push(marker);
    });
  };

  // Filter pins
  const clearOverlays = () => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers.length = 0;
  };

  // Clear filter
  const clearFilter = (map) => {
    clearOverlays();
    initMarkers(dealerMapPinsEle, map);
  };

  const loadGeoJsonWithFallback = (map, primaryUrl, fallbackUrl, callback) => {
    fetch(primaryUrl)
      .then((res) => {
        if (!res.ok) throw new Error('Primary failed');
        return res.json();
      })
      .then((data) => {
        map.data.addGeoJson(data);
        callback();
      })
      .catch(() => {
        console.warn('Primary GeoJSON failed. Loading fallback...');

        fetch(fallbackUrl)
          .then((res) => res.json())
          .then((data) => {
            map.data.addGeoJson(data);
            callback();
          });
      });
  };

  const initialize = (el, mapLat, mapLng, mapZoom) => {
    const mapOptions = {
      zoom: Number(mapZoom),
      center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
      mapTypeControl: false,
      fullscreenControl: false,
      styles: [
        {
          featureType: 'all',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#333333' }],
        },
        {
          featureType: 'all',
          elementType: 'labels.text.stroke',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry',
          stylers: [{ color: '#000000' }, { weight: 0.5 }],
        },
        {
          featureType: 'administrative.country',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#000000' }, { weight: 1 }],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#f9f6f1' }],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#eae6df' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#d0d5cc' }],
        },
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }],
        },
        {
          featureType: 'road',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#cccccc' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#eae6df' }],
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#f0f0f0' }],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#b3d1ec' }],
        },
      ],
    };

    // Countries Hover
    const geoJsonUrl = el.dataset.geojson;
    const map = new google.maps.Map(el, mapOptions);
    const primaryGeoJson = geoJsonUrl;
    const fallbackGeoJson = 'https://raw.githubusercontent.com/datasets/geo-countries/master/data/countries.geojson';

    loadGeoJsonWithFallback(map, primaryGeoJson, fallbackGeoJson, () => {
      map.data.setStyle({
        fillOpacity: 0,
        strokeOpacity: 0,
      });
    });

    const mobileZoom = () => {
      if (windowWidth() < breakpointMd) {
        map.setZoom(8);
      }
    };

    initMarkers(dealerMapPinsEle, map);

    if (windowWidth() >= breakpointMd) {
      const containsPoint = (geom, markerPos) => {
        if (geom.getType() === 'Polygon') {
          return geom
            .getArray()
            .some((path) =>
              google.maps.geometry.poly.containsLocation(
                markerPos,
                new google.maps.Polygon({ paths: path.getArray() }),
              ),
            );
        }

        if (geom.getType() === 'MultiPolygon') {
          return geom
            .getArray()
            .some((poly) =>
              poly
                .getArray()
                .some((path) =>
                  google.maps.geometry.poly.containsLocation(
                    markerPos,
                    new google.maps.Polygon({ paths: path.getArray() }),
                  ),
                ),
            );
        }

        return false;
      };

      map.data.addListener('mouseover', (event) => {
        const { feature } = event;
        const geometry = feature.getGeometry();

        map.data.overrideStyle(feature, {
          fillColor: '#00a1e6',
          fillOpacity: 0.6,
          strokeColor: '#00a1e6',
          strokeWeight: 1,
        });

        markers.forEach((marker) => {
          const markerPos = marker.getPosition();

          if (containsPoint(geometry, markerPos)) {
            marker.div?.classList.add('is-hovered');
          }
        });
      });

      map.data.addListener('mouseout', (event) => {
        const { feature } = event;
        const geometry = feature.getGeometry();

        map.data.revertStyle(feature);

        markers.forEach((marker) => {
          const markerPos = marker.getPosition();

          if (containsPoint(geometry, markerPos)) {
            marker.div?.classList.remove('is-hovered');
          }
        });
      });
    }

    // Location

    attachEvent('.location-details__trigger', 'click', (ev) => {
      const locationDetails = ev.target.closest('.location-details');
      const mainParent = locationDetails.closest('.location-popup');
      mainParent.querySelectorAll('.location-details.is-active').forEach((el) => el.classList.remove('is-active'));
      locationDetails.classList.add('is-active');

      if (windowWidth() < breakpointMd) {
        mainParent.classList.remove('is-open');
      }
    });

    attachEvent('.location-popup__back-button', 'click', () => {
      clearFilter(map);
      setCenterMap(mapLat, mapLng, map);
      mapZoomAndPan(map);
    });

    // Zoom out map for mobile
    mobileZoom();
  };

  dealerMapElements.forEach((el) => {
    const mapLat = el.getAttribute('data-lat');
    const mapLng = el.getAttribute('data-lng');
    const mapZoom = el.getAttribute('data-zoom');

    // eslint-disable-next-line no-unused-vars
    initialize(el, mapLat, mapLng, mapZoom);
  });

  // Check if hash value match with map pin then open
  window.addEventListener('load', () => {
    const { hash } = window.location;

    if (hash) {
      const hashValue = hash.slice(1).toLowerCase(); // get hash value without the '#' symbol
      const targetElem = document.querySelector(`[data-slug="${hashValue}"]`);
      if (targetElem) {
        targetElem.click();
        const targetMarker = markers.find((m) => m.slug.toLowerCase() === hashValue);
        activeMarker = targetMarker;
      }
    }
  });

  // Location Search
  const dealerMapElem = document.querySelector('.dealer-map');
  const searchForm = dealerMapElem.querySelector('.location-popup__footer form');

  if (searchForm) {
    const axiosGetPaginateAndFilteredPosts = async (searchTerm) => {
      const locationPopup = searchForm.closest('.location-popup');

      const action = searchForm.querySelector('[data-action]').value;
      const moduleIndex = searchForm.querySelector('[data-k]').value;

      const formDataInput = {
        action,
        searchTerm,
        moduleIndex,
        id: localData.id,
        nonce: await getNonceForAction(action),
      };

      const innerElem = locationPopup.querySelector('.location-popup__nav-inner');
      const noResultElem = locationPopup.querySelector('.location-popup__not-found');
      const notFoundKeyword = locationPopup.querySelector('.location-popup__not-found-keyword');

      try {
        const { data } = await axios.post(localData.siteURL, formDataInput);
        innerElem.innerHTML = '';

        notFoundKeyword.innerHTML = '';

        if (innerElem && data.data.html_list) {
          innerElem.innerHTML = data.data.html_list;
          locationPopup.classList.remove('no-result-found');
        }

        if (noResultElem && !data.data.html_list) {
          locationPopup.classList.add('no-result-found');
          notFoundKeyword.innerHTML = `“${searchTerm}”`;
        }

        const [baseUrl] = window.location.href.split('?');
        const rawSearchTerm = formDataInput.searchTerm;

        const formattedSearchTerm = rawSearchTerm || '';

        const newUrl = formattedSearchTerm
          ? `${baseUrl}?searchTerm=${encodeURIComponent(formattedSearchTerm)}`
          : baseUrl;

        window.history.pushState({}, '', newUrl);
      } catch (err) {
        console.error(err);
      }
    };

    // Search form submit
    searchForm.addEventListener('submit', (event) => {
      event.preventDefault();

      const locationPopup = document.querySelector('.location-popup');
      if (locationPopup?.classList.contains('is-items-open')) {
        locationPopup.classList.remove('is-items-open');
      }

      const searchTerm = searchForm.querySelector('#location_search').value.trim();
      axiosGetPaginateAndFilteredPosts(searchTerm);
    });

    // Not found back button click
    attachEvent('.dealer-map .location-popup__not-found-back', 'click', (ev) => {
      ev.preventDefault();
      const searchInput = searchForm.querySelector('#location_search');
      searchInput.value = '';
      axiosGetPaginateAndFilteredPosts();
    });
  }
}
